var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #F57224;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.78,0H1.22C.8,0,.42.23.23.6c-.19.37-.16.83.09,1.17l8.63,12.16s0,0,0,.01c.31.42.48.94.48,1.46v9.91c0,.29.11.58.32.78s.49.33.78.33c.15,0,.3-.03.43-.09l4.85-1.85c.43-.13.72-.54.72-1.04v-8.05c0-.53.17-1.04.48-1.46,0,0,0,0,0-.01L25.68,1.77c.25-.34.28-.79.09-1.17-.19-.37-.57-.6-.99-.6ZM15.96,13.15c-.48.65-.74,1.45-.74,2.26v7.89l-4.43,1.69v-9.57c0-.81-.26-1.6-.74-2.26L1.66,1.34h22.68l-8.38,11.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.db0495998467715bd5b5c4853969b449.svg";
export { ForwardRef as ReactComponent };